<template>
  <panel-main-template>
    <template v-slot:page-title>Сотрудники</template>
    <template v-slot:page-info>Внимание! Максимальное количество сотрудников - {{ staffLimit }}</template>
    <template v-slot:page-content>
      <div class="staff--container">
        <div class="alert alert-sm alert-danger" v-if="servListForNewStaff.services.length === 0 && requestCount > 0">
          Похоже, что у вас нет ни одной услуги. Сначала перейдите в раздел "Услуги" и создайте по крайней мере
          одну категорию и одну услугу
        </div>
        <div v-if="servListForNewStaff.services.length > 0" class="actions shadow-card">
          <div v-if="checkPermission('create_staff')" @click="showCreateStaffPopup" class="btn btn-sm btn-success">
            <f-awesome icon="plus"></f-awesome>
            Создать сотрудника
          </div>
        </div>
        <div v-if="servListForNewStaff.services.length > 0" class="my-staff shadow-card mrg-t-25">
          <div class="text-bold">Мои сотрудники</div>
          <div v-if="staffList.length === 0" class="text-center text-orange">
            Пока что не создано ни одного сотрудника.
          </div>
          <ul class="staff--staff-ul">
            <li
              v-for="item in staffList"
              :key="item.id"
              class="staff--staff-li"
            >
              <div class="shadow-card">
                <head-staff-card
                    :img="returnUpdatedImgLink(item.avatar)"
                    :name="item.name"
                    :profession="item.profession"
                    :link="item.link"
                    :linkStatus="+item.link_status"
                    :hide="+item.hide"
                ></head-staff-card>
                <category-staff-card :services="item.staffToServices"></category-staff-card>

                <div class="actions mrg-t-15">
                  <div
                      @click="moveUp(item.id)"
                      class="btn btn-sm btn-outline-info"
                      title="Изменение сортировки. Перемещает сотрудника на 1 позицию вверх"
                  >
                    <f-awesome icon="arrow-up"></f-awesome>
                  </div>
                  <div
                      v-if="checkPermission('delete_staff')"
                      @click="deleteStaff(item.id)"
                      class="btn btn-sm btn-danger"
                  >
                    Удалить
                  </div>
                  <div
                      v-if="checkPermission('update_staff')"
                      @click="openStaffModal(item.id)"
                      class="btn btn-sm btn-info"
                  >
                    Изменить
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <popup
        :closeButton="deletePopup.closeButton"
        :actionButton="deletePopup.actionButton"
        :actionClass="deletePopup.actionClass"
        :show="deletePopup.show"
        @closePopup="closeDeletePopup"
        @actionPopup="deleteSubmit"
      >
        <div slot="header">Подтвердить удаление?</div>
        <div slot="body">
          Сотрудник будет удален без возможности восстановления. Доступ к существующим записям будет ограничен.
          Вы не увидите их в календаре журнала записей, но они будут отображаться в статистике клиентов
        </div>
      </popup>

      <popup
        :closeButton="createStaffPopup.closeButton"
        :actionButton="createStaffPopup.actionButton"
        :actionClass="createStaffPopup.actionClass"
        :show="createStaffPopup.show"
        @closePopup="closeCreateStaffPopup"
        @actionPopup="addStaff"
      >
        <div slot="header">Создание нового сотрудника</div>
        <div slot="body">
          <form class="mrg-t-20" @submit.prevent="addStaff">
            <div class="input-block">
              <label for="staff_name"
              >Имя сотрудника <span class="req">*</span></label>
              <input
                  type="text"
                  @focus="newStaff.errors.name = ''"
                  @blur="validateName"
                  v-model="newStaff.name"
                  id="staff_name"
              />
              <div class="hint">
                Имя сотрудника. Например: "Виктория Сидорова"
              </div>
              <div class="form-error">{{ newStaff.errors.name }}</div>
            </div>
            <div class="input-block">
              <label for="staff_profession"
              >Специальность <span class="req">*</span></label
              >
              <input
                  type="text"
                  @focus="newStaff.errors.profession = ''"
                  @blur="validateProfession"
                  v-model="newStaff.profession"
                  id="staff_profession"
              />
              <div class="hint">
                Специальность. Например: "Мастер ногтевого сервиса"
              </div>
              <div class="form-error">{{ newStaff.errors.profession }}</div>
            </div>
            <div class="staff--avatar">
              <head-staff-card
                  :img="croppie.image"
                  :name="newStaff.name"
                  :profession="newStaff.profession"
              ></head-staff-card>
              <div class="input-block mrg-t-10">
                <label class="btn btn-sm btn-info" for="staff-avatar"
                >Изменить изображение...</label
                >
                <input id="staff-avatar" type="file" @change="changePhoto" />
              </div>
            </div>
            <div class="staff--simple-select">
              <div>Выберите услуги, которые выполняет сотрудник: <span class="text-danger">*</span></div>
              <div class="mrg-t-10">
                <service-list-for-new-staff
                    :data="servListForNewStaff.services"
                    :reset="resetServListForNew"
                    @checked="updateCheckServList"
                ></service-list-for-new-staff>
              </div>
            </div>
            <div class="mrg-t-30"></div>
            <div class="input-block">
              <label>
                <input type="checkbox" v-model="newStaff.link_status">
                Включить личную ссылку просмотра расписания
              </label>
            </div>
            <div class="input-block">
              <label>Какие данные у записей может видеть сотрудник по личной ссылке</label>
              <select v-model="newStaff.link_permission_id">
                <option value="0">Только время</option>
                <option value="1">Время, имя клиента</option>
                <option value="2">Время, услуги</option>
                <option value="3">Время, имя клиента, услуги</option>
                <option value="4">Время, имя клиента, услуги, комментарий компании</option>
              </select>
            </div>
            <div class="input-block">
              <label>Какие данные записей присылает telegram-бот (если привязан)</label>
              <select v-model="newStaff.telegram_permission_id">
                <option value="0">Все данные о записи</option>
                <option value="1">Все, кроме номера телефона</option>
              </select>
            </div>
            <div class="input-block">
              <label>
                <input type="checkbox" v-model="newStaff.block_sms">
                Не отправлять СМС клиенту, если запись к данному сотруднику
              </label>
              <div class="hint">
                Функция будет игнорировать основную настройку уведомлений. Если запись будет произведена к создаваемому
                сотруднику, то СМС отправляться не будет
              </div>
            </div>
            <div class="input-block">
              <label>
                <input type="checkbox" v-model="newStaff.hide">
                Скрыть сотрудника на странице записи
              </label>
              <div class="hint">
                При выборе данного пункта, сотрудник не будет отображаться на странице записи онлайн,
                но в разделе "Журнал записей" вы сможете с ним работать
              </div>
            </div>
          </form>
          <croppie-component
            :fileModel="croppie.fileModel"
            @croppieSubmit="croppieSubmit"
          ></croppie-component>
        </div>
      </popup>

      <croppie-component
          :fileModel="editCroppie.fileModel"
          @croppieSubmit="editCroppieSubmit"
      ></croppie-component>

      <right-modal :show="showEditModal" @closeRightModal="closeStaffModal">
        <div slot="body">
          <edit-staff
            @updateStaff="updateStaff"
            @changePhoto="editCroppieChangePhoto"
            @setCroppieImage="setEditCroppieImage"
            @setCroppieImageBase="setEditCroppieImageBase"
            :show="showEditModal"
            :servList="mixUpData(servListForNewStaff.servicesForEdit)"
            :id="editStaffId"
            :croppieData="editCroppie"
          ></edit-staff>
        </div>
      </right-modal>
    </template>
  </panel-main-template>
</template>

<script>
// @ is an alias to /src

import PanelMainTemplate from "../../components/panel/MainTemplate";
import CroppieComponent from "../../components/CroppieComponent";
import Popup from "../../components/Popup";
import Validator from "../../components/libraries/Validator";
import RightModal from "../../components/RightModal";
import EditStaff from "../../components/panel/staff/EditStaff";
import HeadStaffCard from "@/components/panel/staff/HeadStaffCard";
import CategoryStaffCard from "@/components/panel/staff/CategoryStaffCard";
import permissionMixin from "@/components/mixins/Permissions";
import ServiceListForNewStaff from "../../components/panel/staff/ServiceListForNewStaff";
import CopyArrayAndObject from "@/components/libraries/CopyArrayAndObject";
import staffRepository from "../../repositories/staff";

const copyArrObj = new CopyArrayAndObject();

const validator = new Validator();

export default {
  name: "Staff",
  components: {
    ServiceListForNewStaff,
    CategoryStaffCard,
    HeadStaffCard,
    EditStaff,
    RightModal,
    Popup,
    PanelMainTemplate,
    CroppieComponent
  },
  mixins: [permissionMixin],
  data() {
    return {
      editCroppie: {
        image: null, // основная картинка для отображения. Null если должна быть пустая
        imageBase: null, // хэш из компонента CroppieComponent для передачи в REST
        fileModel: null, // записываем сюда event из инпута с type = file для передачи в CroppieComponent
        stImage: null
      },
      croppie: {
        image: null, // основная картинка для отображения. Null если должна быть пустая
        imageBase: null, // хэш из компонента CroppieComponent для передачи в REST
        fileModel: null, // записываем сюда event из инпута с type = file для передачи в CroppieComponent
        stImage: null
      },
      newStaff: {
        name: "",
        profession: "",
        link_status: false,
        link_permission_id: 0,
        telegram_permission_id: 0,
        block_sms: 0,
        hide: 0,
        errors: {
          name: "",
          profession: ""
        }
      },
      resetServListForNew: 0,
      requestCount: 0,
      servListForNewStaff: {
        services: [], // Передаем список, который будет выбираться
        servicesForEdit: [],
        selectedServices: {
          selectedServices: [],
          selectedModifications: []
        } // Сюда попадает список выбранных id
      },
      staffList: [],
      staffLimit: "",
      deleteId: "",
      deletePopup: {
        show: false,
        closeButton: "Отмена",
        actionButton: "Подтвердить",
        actionClass: "btn-success"
      },
      createStaffPopup: {
        show: false,
        closeButton: "Отмена",
        actionButton: "Добавить",
        actionClass: "btn-success"
      },
      showEditModal: false,
      editStaffId: ""
    };
  },
  metaInfo: {
    title: "Сотрудники - Enroller",
    meta: [
      {
        name: 'viewport',
        content: "width=device-width, initial-scale=1, minimum-scale=1, user-scalable=no"
      }
    ]
  },
  watch: {},
  computed: {
    validateAll() {
      let errorCount = 0;
      this.validateName().result == "error" ? errorCount++ : "";
      this.validateProfession().result == "error" ? errorCount++ : "";

      return errorCount;
    }
  },
  methods: {
    setEditCroppieImageBase(data){
      this.editCroppie.imageBase = data;
    },
    setEditCroppieImage(data){
      this.editCroppie.image = data;
    },
    editCroppieSubmit(data){
      this.editCroppie.image = data;
      this.editCroppie.imageBase = data;
    },
    editCroppieChangePhoto(file){
      this.editCroppie.fileModel = file;
    },
    showCreateStaffPopup(){
      this.createStaffPopup.show = true;
    },
    closeCreateStaffPopup(){
      this.createStaffPopup.show = false;
    },
    mixUpData(data){
      return copyArrObj.copy(data);
    },
    returnUpdatedImgLink(link) {
      let now = new Date();
      return link + "?update=" + now.getTime();
    },
    validateName() {
      let vStaffName = validator.validate([
        {
          fieldName: "Имя сотрудника",
          value: this.newStaff.name,
          type: "required"
        },
        {
          fieldName: "Имя сотрудника",
          value: this.newStaff.name,
          type: "string",
          length: 255
        }
      ]);
      vStaffName.result == "error"
        ? (this.newStaff.errors.name = vStaffName.message)
        : (this.newStaff.errors.name = "");
      return vStaffName;
    },
    validateProfession() {
      let vProfession = validator.validate([
        {
          fieldName: "Специальность",
          value: this.newStaff.profession,
          type: "required"
        },
        {
          fieldName: "Специальность",
          value: this.newStaff.profession,
          type: "string",
          length: 255
        }
      ]);
      vProfession.result == "error"
        ? (this.newStaff.errors.profession = vProfession.message)
        : (this.newStaff.errors.profession = "");
      return vProfession;
    },
    addStaff() {
      if (this.validateAll) {
        return false;
      }
      if (
          !this.servListForNewStaff.selectedServices.selectedServices.length &&
          !this.servListForNewStaff.selectedServices.selectedModifications.length
      ) {
        this.$store.dispatch("addNotification", {
          text: "Не заданы услуги для добавляемого сотрудника",
          time: 5,
          color: "danger"
        });
        return false;
      }
      this.$store.dispatch("startPreloader");

      const data = {
        name: this.newStaff.name,
        profession: this.newStaff.profession,
        link_status: this.newStaff.link_status,
        link_permission_id: this.newStaff.link_permission_id,
        telegram_permission_id: this.newStaff.telegram_permission_id,
        block_sms: this.newStaff.block_sms,
        hide: this.newStaff.hide,
        avatar: this.croppie.imageBase,
        services: JSON.stringify(this.servListForNewStaff.selectedServices)
      };

      staffRepository.addStaff(data).then(resp => {
        this.staffList = resp.data;
        this.newStaff.name = "";
        this.newStaff.profession = "";
        this.newStaff.hide = 0;
        this.croppie.image = this.returnUpdatedImgLink(this.croppie.stImage);
        this.croppie.imageBase = null;
        this.resetServListForNew++;
        this.servListForNewStaff.selectedServices.selectedServices = [];
        this.servListForNewStaff.selectedServices.selectedModifications = [];
        this.$store.dispatch("addNotification", {
          text: "Сотрудник успешно добавлен",
          time: 3,
          color: "success"
        });
        this.closeCreateStaffPopup();
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    updateStaff(data) {
      for (let key in this.staffList) {
        if (+this.staffList[key].id === +data.id) {
          this.staffList[key] = data;
        }
      }
      this.closeStaffModal();
    },
    closeDeletePopup() {
      this.deletePopup.show = false;
    },
    deleteStaff(id) {
      this.deleteId = id;
      this.deletePopup.show = true;
    },
    deleteSubmit() {
      this.$store.dispatch("startPreloader");

      staffRepository.deleteStaff({id: this.deleteId}).then(resp => {
        this.staffList = resp.data;
        this.deletePopup.show = false;
        this.$store.dispatch("addNotification", {
          text: "Сотрудник успешно удален",
          time: 3,
          color: "success"
        });
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    openStaffModal(id) {
      this.showEditModal = true;
      this.editStaffId = id;
    },
    closeStaffModal() {
      this.showEditModal = false;
    },
    changePhoto(file) {
      this.croppie.fileModel = file;
    },
    croppieSubmit(data) {
      this.croppie.image = data;
      this.croppie.imageBase = data;
    },
    changeCatSelect(val) {
      this.simpleSelect.selectedCategories = val;
    },
    updateCheckServList(list){
      this.servListForNewStaff.selectedServices = list;
    },
    moveUp(id){
      this.$store.dispatch("startPreloader");

      staffRepository.moveUp({id: id}).then(resp => {
        this.staffList = resp.data;
        this.$store.dispatch("addNotification", {
          text: "Сотрудник успешно перемещен вверх",
          time: 3,
          color: "success"
        });
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    }
  },
  created() {
    this.$store.dispatch("startPreloader");

    staffRepository.getDataPage().then(resp => {
      this.croppie.image = this.returnUpdatedImgLink(resp.data.st_avatar);
      this.croppie.stImage = resp.data.st_avatar;
      this.servListForNewStaff.services = resp.data.actual_cat_with_service;
      this.servListForNewStaff.servicesForEdit = resp.data.actual_cat_with_service;
      this.staffList = resp.data.staff_list;
      this.staffLimit = resp.data.staff_limit.staff_limit;
      this.requestCount++;
      this.$store.dispatch("stopPreloader");
    }).catch(err => {
      this.$store.dispatch("addNotification", {
        text: err.response.data.message,
        time: 6,
        color: "danger"
      });
      this.$store.dispatch("stopPreloader");
    });
  }
};
</script>

<style scoped lang="less">
.staff--simple-select {
  margin-bottom: 35px;
}
.staff--avatar {
  width: 270px;
  text-align: left;
}

.staff--staff-ul {
  padding-left: 0;
  margin-left: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;

  .staff--staff-li {
    width: 320px;
    margin: 25px 20px;
    list-style-type: none;
    display: inline-block;
    position: relative;

    .name {
      font-size: 17px;
      font-weight: 700;
      color: #333;
      line-height: 20px;
    }
    .profession {
      font-size: 15px;
      color: gray;
    }
    .img {
      margin-top: 10px;

      img {
        width: 80px;
      }
    }
    .cat-list {
      margin-top: 10px;
      color: #333;
    }
    .cat-title {
      font-size: 17px;
      font-weight: 700;
    }
    .cat-item {
      font-size: 15px;
      border-bottom: 1px solid gray;
    }
    .actions {
      text-align: right;
    }
  }
}
@media (max-width: 700px) {
  .my-staff{
    margin-top: 20px;
  }
  .staff--container {
    flex-wrap: wrap;

    & > div {
      width: 100%;
    }
  }
  .staff--staff-ul {
    justify-content: space-around;

    .staff--staff-li {
      width: 320px;
      margin: 20px 0px;
    }
  }
}
</style>
